import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useMonetaryAmount } from '@sorare/core/src/hooks/useMonetaryAmount';

import type { useSortPrimaryBuys_anyCard } from './__generated__/useSortPrimaryBuys.graphql.ts';

type Props<T extends useSortPrimaryBuys_anyCard> = {
  anyCards?: T[];
};
export const useSortPrimaryBuys = <T extends useSortPrimaryBuys_anyCard>({
  anyCards = [],
}: Props<T>): T[] => {
  const { toMonetaryAmount } = useMonetaryAmount();

  const sortedCards = [...anyCards]?.sort((cardA, cardB) => {
    const priceA = toMonetaryAmount(cardA.livePrimaryOffer?.price);
    const priceB = toMonetaryAmount(cardB.livePrimaryOffer?.price);

    return priceA.eurCents - priceB.eurCents;
  });

  return sortedCards;
};

useSortPrimaryBuys.fragments = {
  anyCard: gql`
    fragment useSortPrimaryBuys_anyCard on AnyCardInterface {
      slug
      livePrimaryOffer {
        id
        price {
          ...useMonetaryAmount_monetaryAmount
        }
      }
    }
    ${useMonetaryAmount.fragments.monetaryAmount}
  ` as TypedDocumentNode<useSortPrimaryBuys_anyCard>,
};
